import throttle from 'lodash/throttle';
import React, { useState, useRef, useEffect } from 'react';
import { StyleSheet, Text, View, TextInput as RNTextInput } from 'react-native';

import {
  useConfirmResetEmailMutation,
  useInitiateResetEmailMutation,
} from 'apollo/queries/autogenerate/hooks';
import { PinCodeDispatchMethod } from 'apollo/queries/autogenerate/schemas';
import CodeInput from 'shared/modules/common/components/atoms/CodeInput';
import OTPTimer from 'shared/modules/common/components/organisms/OTPTimer';

const EditUserEmailEnterMobileOTP = (props: {
  onSuccess: () => void;
  email: string;
}) => {
  const [confirmResetMutation] = useConfirmResetEmailMutation();
  const [smsOtp, setSmsOtp] = useState('');
  const [showError, setShowError] = useState(false);
  const [initiateEmailMutation] = useInitiateResetEmailMutation();
  const codeInputRef = useRef<RNTextInput>(null);

  useEffect(() => {
    codeInputRef.current?.focus();
  }, []);

  // Sends an OTP code to the email address the user want to become a new email
  // So this can be invoked to request a new OTP
  const submitSMSOTP = async (code?: string) => {
    setShowError(false);

    try {
      await confirmResetMutation({
        variables: {
          otp: code || smsOtp,
        },
      });

      if (code) {
        setSmsOtp(code);
        props.onSuccess();
      }
    } catch (err) {
      setShowError(true);
    }
  };

  // Sends an OTP code to user's phone
  // So this can be invoked to request a new OTP
  const submitNewEmail = throttle(
    async () => {
      try {
        await initiateEmailMutation({
          variables: {
            newEmail: props.email,
            pinCodeDispatchMethod: PinCodeDispatchMethod.VOICE,
          },
        });
      } catch (err) {
        console.error('入力内容を確認してください');
      }
    },
    2000,
    { leading: true, trailing: false }
  );

  return (
    <>
      <View style={style.topContainer}>
        <View style={style.spacer} />
        <Text style={style.title}>
          SMSに送信された4桁の認証コードを入力してください。
        </Text>
        <View style={style.spacer} />
        <View style={style.otp}>
          <CodeInput
            onFulFill={submitSMSOTP}
            style={style.codeField}
            errorMessage="認証コードが違います"
            showError={showError}
            id="edit-user-email-code-field"
            ref={codeInputRef}
          />
        </View>
      </View>
      <OTPTimer sentToLabel="自動音声案内" onPress={submitNewEmail} />
    </>
  );
};

const style = StyleSheet.create({
  title: {
    fontSize: 16,
    fontWeight: '300',
    lineHeight: 24,
  },
  otp: {
    alignItems: 'center',
  },
  codeField: {
    width: 288,
  },
  spacer: {
    marginBottom: 24,
  },
  topContainer: {
    flexGrow: 1,
  },
});

export default EditUserEmailEnterMobileOTP;
